import { Injectable } from '@angular/core';
import { EmailDeposit } from '@model/email-deposit-model';
import { IEmailLoggable } from '@services/strategy-pattern-login/iEmail-loggable';

@Injectable({
  providedIn: 'root'
})
export class IEmailAdapterService implements IEmailLoggable {

  constructor() { }

  sendEmail(isRedemption: boolean, depositParams: EmailDeposit) {
    throw new Error('Method not implemented.');
  }

  getEmail() {
    throw new Error('Method not implemented.');
  }

}
